import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export const SvgChevronRightSingle = () => {
    return (_jsx("svg", Object.assign({ viewBox: "0 0 30 30", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.975 4L9 4.95L17.325 14.925L9 24.8999L9.975 25.8499L20.375 15.45V14.4L9.975 4Z" }, void 0) }), void 0));
};
//# sourceMappingURL=chevron-right-single.js.map
